<template>
    <div class="main-section" v-if="messages" :class="{'main-section--full' : techChatForm || mutedForm}">
        <div class="message-pin" v-if="pinnedMessage && (pinnedMessage.pin || pinnedMessage.id)">
            <div class="pin-body" @click="getPinnedMessage">
                <img :src="env.public_base + '/assets/images/pin-icon.svg'" class="pin__icon-pin" alt="">

                <div class="pin-body__info">
                    <div class="pin-body__user">
                        <p>{{ pinnedMessage.author.last_name }} {{ pinnedMessage.author.first_name }}</p>
                        <span>{{ pinnedMessage.created | formatDateMmDdYyyy }}</span>
                    </div>

                    <p v-html="pinnedMessage.text" @paste="sanitize"></p>
                </div>
            </div>

            <button type="button" class="pin__icon-unpin" @click="unpin" v-if="userData.role === 'admin' || userData.role === 'teacher'">
                <img :src="env.public_base + '/assets/images/cross-icon--blue.svg'" alt="">
            </button>
        </div>

        <div class="container-chat"
             :class="{'container-chat--pinned' : pinnedMessage && pinnedMessage.pin}"
        >
            <vue-custom-scrollbar
                id="main-chat-section"
                class="scroll-area"
                :class="{'main-chat-section--height' : true}"
                :settings="settings"
                @ps-scroll-up="showButton"
                @ps-scroll-down="enableScrollTop()"
                @ps-y-reach-end="scrolledToBottom"
                @ps-y-reach-start="scrolledToTop"
            >
                <ul class="main-chat" id="mainChat" :key="chatKey">
                    <app-message v-for="(message, index) in messages" :message="message" :key="index"></app-message>
                </ul>
            </vue-custom-scrollbar>
        </div>
    </div>
</template>

<script>
    import  {mapGetters } from 'vuex';
    import Message from './Message.vue';
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import env from '../../env'
    import eventBus from "../../courses/eventBus";

    export default {
        data: () => ({
            env,
            settings: {
                maxScrollbarLength: 60,
                swipeEasing: true,
                suppressScrollX: true
            },
            messageIdFirst: '',
            messageIdLast: '',
        }),
        components: {
            appMessage: Message,
            vueCustomScrollbar: vueCustomScrollbar,
        },
        computed: {
            ...mapGetters([
                'channel',
                'messages',
                'mainChat',
                'techChat',
                'techChatsIds',
                'userData',
                'pinnedMessage',
            ]),
            chatKey() {
                return this.mainChat.key
            },
            techChatForm() {
                if(this.channel !== undefined && this.channel !== null) {
                    return this.techChatsIds.some(el => el === this.channel.id) && this.userData.role !== 'admin' &&
                        this.userData.role !== 'moderator' && this.userData.role !== 'teacher'
                } else {
                    return false
                }
            },
            mutedForm() {
                return this.channel &&
                    ((this.userData.role === 'student' || this.userData.role === 'student/billing') &&
                        this.channel.disable_to_write) || (this.userData.is_muted && this.channel.is_group);
            }
        },
        mounted() {
            let mainChatSection = document.getElementById("main-chat-section");

            // mainChatSection.scrollTop = 10;
        },
        methods: {
            sanitize(event) {
                event.preventDefault();
                const html = this.$sanitize(event.clipboardData.getData('text/html'));
                document.execCommand('insertHTML', false, (html));
            },
            getPinnedMessage() {
                let params = {
                    'channel_id': this.channel.id,
                    'query': {
                        'offset': 0,
                        'limit': 10,
                        'id__gte': this.pinnedMessage.messageId,
                        'lang': localStorage.getItem('language')
                    },
                };

                this.$store.dispatch('channel_messages', params).then(res => {
                    this.$store.commit('SET_MESSAGES', res.data.results);
                    const mainChatSection = document.getElementById("main-chat-section");
                    mainChatSection.scrollTop = 1;

                    if(res.data.results.length <= 6) {
                        delete params.query['id__gte'];
                        params.query['id__lt'] = this.pinnedMessage.messageId;
                        params['scroll'] = 0;
                        this.$store.dispatch('channel_messages', params)
                    }
                }, err => console.log(err))
            },
            unpin() {
                let data = {messageId: this.pinnedMessage.messageId, pin: false};
                eventBus.$emit('pin_message', data);
            },
            showButton() {
                this.$store.commit('USER_AT_BOTTOM', false);
                this.$store.commit('SET_FOR_COMPONENT', {page: 'mainChat', field: 'scrollButton', value: true});
            },
            enableScrollTop() {
                this.showButton();
                this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'scrollable', value: true});
            },
            scrolledToTop() {
                if(!this.mainChat.scrollable) return;

                if (typeof this.messages !== 'undefined' && Object.entries(this.messages).length !== 0) {
                    if (this.messageIdFirst === Object.entries(this.messages)[0][1].id) return;

                    let params = {
                        'channel_id': this.channel.id,
                        'query': {
                            'offset': 0,
                            'limit': 10,
                            'id__lt': Object.entries(this.messages)[0][1].id,
                            'lang': localStorage.getItem('language')
                        },
                        'scroll': 0,
                    };
                    let ids = [];

                    this.$store.dispatch('channel_messages', params).then(response => {

                        if (response.data.results.length !== 0) {
                            Object.values(response.data.results).forEach(item => {
                                ids.push(+item.id);
                            });

                            let messages = {
                                'params': {
                                    'chat_message_ids': ids,
                                    'lang': localStorage.getItem('language')
                                },
                                'channel_id': this.channel.id
                            };
                            this.$store.dispatch('setMessagesRead', messages);

                        } else if (response.data.results.length <= 4) {
                            this.$store.commit('SET_FOR_COMPONENT', {
                                page: 'mainChat',
                                field: 'scrollButton',
                                value: false
                            });
                        }

                    }, err => console.log(err, "error"));

                    this.messageIdFirst = Object.entries(this.messages)[0][1].id;
                    this.$store.commit('USER_AT_BOTTOM', false);
                }
            },
            scrolledToBottom() {
                if (typeof this.messages !== 'undefined' && Object.entries(this.messages).length !== 0) {
                    this.$store.commit('SET_FOR_COMPONENT', {page: 'mainChat', field: 'scrollButton', value: false});

                    if (this.messageIdLast === Object.entries(this.messages)[Object.keys(this.messages).length - 1][1].id) return;
                    let params = {
                        'channel_id': this.channel.id,
                        'query': {
                            'offset': 0,
                            'limit': 10,
                            'id__gt': Object.entries(this.messages)[Object.keys(this.messages).length - 1][1].id,
                            'lang': localStorage.getItem('language')
                        },
                    };

                    if (Object.keys(this.messages).length <= 9) {
                        params.query['id__lte'] = Object.entries(this.messages)[Object.keys(this.messages).length - 1][1].id;
                        delete params.query['id__gt'];
                    }
                    let ids = [];
                    this.$store.dispatch('channel_messages', params).then(response => {

                        if (response.data.results.length !== 0) {
                            Object.values(response.data.results).forEach(item => {
                                ids.push(+item.id);
                            });

                            let messages = {
                                'params': {
                                    'chat_message_ids': ids,
                                    'lang': localStorage.getItem('language')
                                },
                                'channel_id': this.channel.id
                            };
                            this.$store.dispatch('setMessagesRead', messages);

                            if(typeof params.query['id__lte'] !== 'undefined') {
                                this.$store.dispatch('scrollChatSection');
                            }

                        } else if (response.data.results.length <= 4) {
                            this.$store.commit('SET_FOR_COMPONENT', {
                                page: 'mainChat',
                                field: 'scrollButton',
                                value: false
                            });
                            // this.$store.dispatch('scrollChatSection', {seconds: 250});
                        }

                    }, err => console.log(err, "error"));

                    this.messageIdLast = Object.entries(this.messages)[Object.keys(this.messages).length - 1][1].id;
                    this.$store.commit('USER_AT_BOTTOM', true);
                }
            },
        }
    }
</script>

<style lang="sass" scoped>

    .scroll-area
        position: relative
        /*margin: auto*/
        width: 100%
        height: 100%

</style>
